export const styles = {
  header: { marginBottom: '28px' },
  heading: { fontSize: '28px', fontWeight: '700', color: 'var(--color-text)', margin: '0 0 4px' },
  sub: { fontSize: '15px', color: '#6b6b7a', margin: 0 },
  muted: { color: '#6b6b7a', fontStyle: 'italic' },

  pageLayout: { display: 'flex', gap: '28px', alignItems: 'flex-start' },
  mainCol: { flex: 1, minWidth: 0 },
  sidebar: { width: '272px', minWidth: '272px', position: 'sticky', top: '32px' },

  sectionBox: {
    marginBottom: '20px', padding: '20px',
    backgroundColor: 'var(--color-background)', border: '2px solid #e5e0d5',
    borderRadius: '14px',
  },
  sectionBoxError: {
    borderColor: '#dc2626',
    backgroundColor: 'color-mix(in srgb, #dc2626 4%, var(--color-background))',
  },
  sectionTitleRow: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px', flexWrap: 'wrap' },
  sectionLabel: { fontSize: '13px', fontWeight: '700', color: '#374151', marginBottom: '10px' },
  inlineError: { fontSize: '12px', color: '#dc2626', fontWeight: '600' },

  optRow: { display: 'flex', gap: '10px' },
  sizeBtn: {
    display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
    padding: '12px 18px', backgroundColor: 'var(--color-background)', border: '2px solid #e5e0d5',
    borderRadius: '10px', cursor: 'pointer', fontFamily: 'system-ui, sans-serif',
    fontSize: '16px', fontWeight: '700', color: 'var(--color-text)', transition: 'all 0.15s',
  },
  sizeBtnActive: { border: '2px solid var(--color-primary)', backgroundColor: 'color-mix(in srgb, var(--color-surface) 15%, var(--color-background))' },
  sizeBtnSub: { fontSize: '11px', fontWeight: '400', color: '#6b6b7a', marginTop: '2px' },
  subLabel: { fontSize: '12px', fontWeight: '600', color: '#374151', marginBottom: '8px' },

  patternGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
    gap: '8px',
  },
  patternBtn: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px',
    padding: '12px 8px', backgroundColor: 'var(--color-background)', border: '2px solid #e5e0d5',
    borderRadius: '10px', cursor: 'pointer', fontFamily: 'system-ui, sans-serif',
    transition: 'all 0.15s',
  },
  patternBtnActive: { border: '2px solid var(--color-primary)', backgroundColor: 'color-mix(in srgb, var(--color-surface) 15%, var(--color-background))' },
  patternBtnLabel: { fontSize: '13px', fontWeight: '700', color: 'var(--color-text)' },
  patternBtnDesc: { fontSize: '11px', color: '#6b6b7a', textAlign: 'center', lineHeight: '1.3' },

  patternTooltip: {
    position: 'absolute', bottom: 'calc(100% + 10px)', left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#fff', border: '1px solid #e5e0d5', borderRadius: '12px',
    padding: '14px 16px', boxShadow: '0 6px 20px rgba(0,0,0,0.13)',
    zIndex: 200, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px',
    minWidth: '130px', pointerEvents: 'none',
  },
  patternTooltipTitle: { fontSize: '13px', fontWeight: '700', color: 'var(--color-text)' },
  patternTooltipDesc: { fontSize: '11px', color: '#6b6b7a', textAlign: 'center', lineHeight: '1.4' },

  novelGridScroll: {
    maxHeight: '240px',
    overflowY: 'auto',
    padding: '2px',
  },
  novelGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    gap: '12px',
  },
  novelCard: {
    backgroundColor: 'var(--color-background)', border: '2px solid #e5e0d5', borderRadius: '12px',
    padding: '20px', textAlign: 'left', cursor: 'pointer',
    fontFamily: 'system-ui, sans-serif', width: '100%', transition: 'all 0.15s',
  },
  novelCardSelected: { border: '2px solid var(--color-primary)', backgroundColor: 'color-mix(in srgb, var(--color-surface) 15%, var(--color-background))' },
  novelCardDisabled: { opacity: 0.5, cursor: 'not-allowed' },
  customizeNudge: { fontSize: '12px', color: '#6b6b7a', margin: '10px 2px 0', lineHeight: '1.5' },
  customizeNudgeLink: {
    background: 'none', border: 'none', padding: 0, margin: 0,
    fontSize: '12px', color: 'var(--color-primary)', cursor: 'pointer',
    fontFamily: 'inherit', textDecoration: 'none',
  },
  novelTitle: { fontSize: '16px', fontWeight: '600', color: 'var(--color-text)', marginBottom: '4px' },
  novelMeta: { fontSize: '13px', color: '#6b6b7a', marginBottom: '8px' },
  wordCountNeutral: { fontSize: '12px', color: '#6b6b7a', fontWeight: '600' },
  wordCountLow: { fontSize: '12px', color: '#dc2626', fontWeight: '600' },

  emptyCard: {
    backgroundColor: 'var(--color-background)', border: '1px solid #e5e0d5', borderRadius: '12px',
    padding: '32px',
  },
  emptyText: { color: '#6b6b7a', fontSize: '15px', margin: 0, lineHeight: '1.6' },
  searchInput: {
    width: '100%', padding: '10px 14px', fontSize: '15px',
    border: '2px solid #e5e0d5', borderRadius: '8px', boxSizing: 'border-box',
    outline: 'none', marginBottom: '12px', fontFamily: 'system-ui, sans-serif',
  },

  summaryCard: {
    backgroundColor: 'var(--color-background)', border: '2px solid #e5e0d5',
    borderRadius: '14px', padding: '22px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
  },
  summaryHeading: { fontSize: '15px', fontWeight: '700', color: 'var(--color-text)', margin: '0 0 14px' },
  summaryRows: { marginBottom: '18px' },
  summaryRow: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
    gap: '10px', padding: '9px 0', borderBottom: '1px solid #f0ece5',
  },
  summaryRowLabel: { fontSize: '12px', color: '#6b6b7a', fontWeight: '500', flexShrink: 0 },
  summaryRowValue: { fontSize: '12px', color: 'var(--color-text)', fontWeight: '700', textAlign: 'right', lineHeight: '1.4' },
  summaryRowMissing: { fontSize: '12px', color: '#dc2626', fontWeight: '500', textAlign: 'right', fontStyle: 'italic' },

  error: { color: '#dc2626', fontSize: '13px', marginBottom: '12px', marginTop: '0' },

  existingGame: {
    border: '1px solid #fcd34d', backgroundColor: '#fffbeb', borderRadius: '8px',
    padding: '12px', marginBottom: '12px',
  },
  existingGameText: { fontSize: '13px', color: 'var(--color-text)', margin: '0 0 10px', lineHeight: '1.4' },
  existingGameActions: { display: 'flex', gap: '8px', flexWrap: 'wrap' },
  existingGameBtn: {
    flex: '1 1 auto', padding: '8px 12px', borderRadius: '6px', border: '1px solid #d1d5db',
    backgroundColor: '#fff', fontSize: '13px', fontWeight: '600', cursor: 'pointer',
    fontFamily: 'system-ui, sans-serif', color: 'var(--color-text)',
  },
  existingGameBtnDanger: { borderColor: '#dc2626', color: '#dc2626' },

  createBtn: {
    width: '100%', padding: '13px 20px', border: 'none',
    borderRadius: '8px', fontSize: '15px', fontWeight: '700', cursor: 'pointer',
    transition: 'all 0.15s', fontFamily: 'system-ui, sans-serif',
    color: '#fff',
  },
  createBtnActive: { backgroundColor: 'var(--color-accent)' },
  createBtnDisabled: { backgroundColor: '#9ca3af', cursor: 'not-allowed' },
  createHint: { fontSize: '12px', color: '#6b6b7a', textAlign: 'center', margin: '10px 0 0', lineHeight: '1.4' },
};
